import React from "react";
import PropTypes from "prop-types";

import { useText } from "components/Text";
import { useCurrentTenant } from "contexts/currentTenant";
import { getSealURL } from "reducers/tenant";

const Seal = ({ type, style }) => {
  const tenant = useCurrentTenant();
  const sealURL = getSealURL(tenant, type);
  const sealName = useText("seal_name");

  return <img src={sealURL} alt={sealName} style={style} />;
};

Seal.propTypes = {
  type: PropTypes.string.isRequired,
  style: PropTypes.object,
};

export default Seal;
